(function(){
  if (window.__sbInit) return; window.__sbInit = true;
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('sb-anim');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function init(){ document.querySelectorAll('.sb-reveal:not(.is-in)').forEach(function(el){ io.observe(el); }); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
